import { ShieldCheck } from 'lucide-react';

export default function GuaranteeSection() {
  return (
    <section className="py-10 md:py-14 px-4">
      <div className="max-w-2xl mx-auto text-center">
        <ShieldCheck className="w-8 h-8 md:w-10 md:h-10 text-blue-400 mx-auto mb-3 md:mb-4" />
        <h2 className="text-xl md:text-3xl font-extrabold mb-3 md:mb-4">
          The 30-Day Guarantee
        </h2>
        <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-xl mx-auto">
          Use AthnxGym for 30 days from the day your account is fully set up.
          If you don't identify and prevent at least one equipment issue,
          we'll refund your first month — <span className="text-blue-400 font-semibold">no questions, no hassle.</span>
        </p>
        <p className="text-white/30 text-xs mt-4">
          30-day clock starts from onboarding completion, not payment date.
        </p>
      </div>
    </section>
  );
}
